module.exports = __webpack_public_path__ + "components/flag/static/square/es-ga-35b6430c2407dfe8f206a157c8333460.svg";